import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const DynamicBrandPagePageContainer = props => {
  return <LazyLoaderWrapper importPath='BRAND_PAGE_ROUTE' {...props} />;
};

export default DynamicBrandPagePageContainer;
